export enum TableEntity {
    Profile = 'Profile',
    Buyer = 'Buyer',
    Producer = 'Producer',
    NoEntity = 'NoEntity',
}